import React from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const defaultRtlSx = {
  direction: "rtl",
    "& .css-cnqma5-MuiFormHelperText-root":{
textAlign:"right"
},
"& .css-h2bes-MuiFormHelperText-root":{
textAlign:"right"
},
  "& .MuiInputLabel-root": {
    right: "26px",
    left: "auto",
    transformOrigin: "top right",
    textAlign: "right",
    position: "absolute",
  },
  "& .MuiOutlinedInput-root": {
    textAlign: "right",
    position: "relative",

    "& input": {
      textAlign: "right",
    },

    "& .MuiSelect-select": {
      paddingRight: "44px !important", 
      paddingLeft: "12px !important",
    },

    "& .MuiSelect-icon": {
      right: "auto",
      left: 8,
      pointerEvents: "none",
      position: "absolute",
    },
    "& .css-p1olib-MuiAutocomplete-endAdornment": {
      right: "auto",
      left: 8,
    },
    "& .MuiInputAdornment-root": {
      left: 8,
      right: "auto",
    },

    "& fieldset": {
      paddingInlineEnd: "8px",
    },
  },


  "& legend": {
    textAlign: "right",
    direction: "rtl",
  },
};


const CustomTextField = React.forwardRef(function CustomTextField(props, ref) {
  const {
    sx,
    InputProps,
    inputProps,
    isRtl = true,
    SelectProps,
    variant = "outlined",
    ...other
  } = props;
  let combinedSx;
  if (isRtl) {
    combinedSx = Array.isArray(sx) ? [defaultRtlSx, ...sx] : [defaultRtlSx, sx];
  } else {
    combinedSx = sx;
  }

  const combinedSelectProps = {
    ...SelectProps,
    IconComponent: SelectProps?.IconComponent || ArrowDropDownIcon,
  };

  const combinedInputProps = {
    dir: inputProps?.dir || (isRtl ? "rtl" : "ltr"),
    ...inputProps,
  };

  return (
    <TextField
      {...other}
      variant={variant}
      sx={combinedSx}
      inputRef={ref}
      InputProps={InputProps}
      inputProps={combinedInputProps}
      SelectProps={other.select ? combinedSelectProps : SelectProps}
    />
  );
});

CustomTextField.propTypes = {
  label: PropTypes.node,
  id: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  variant: PropTypes.oneOf(["outlined", "filled", "standard"]),
  type: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
  isRtl: PropTypes.bool,
};

CustomTextField.defaultProps = {
  variant: "outlined",
  sx: {},
  isRtl: true,
};

export default CustomTextField;